import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
    root: {
        // margin: '0px 15px',
        ['@media (max-width:480px)']: {
            //margin: '0px'
        }
    }
}));